import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material"
import { ReserveClubhouseRequestData } from "../../clients"
import { MyClubhouseReservationRequestsRow } from "./MyClubhouseReservationRequestsRow"

interface MyClubhouseReservationRequestsTableProps {
    requests: ReserveClubhouseRequestData[]
    handleViewRequest: (request: ReserveClubhouseRequestData) => void
}

export const MyClubhouseReservationRequestsTable = ({ requests, handleViewRequest }: MyClubhouseReservationRequestsTableProps) => {
        return (
            <TableContainer>
                <Table sx={{ minWidth: '600px', width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Reservation Dates</TableCell>
                            <TableCell>Requested Date</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {requests.map((request: ReserveClubhouseRequestData) => (
                            <MyClubhouseReservationRequestsRow key={request.reserveClubhouseRequestId} request={request} handleViewRequest={handleViewRequest} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        )
}